import React from 'react';
import { useTranslation } from 'react-i18next';
import css from '../../summary-view.module.css';
import SummaryGraph from '../../summary-graph';
import { formatDateValue } from '../../../../../services/utils';
import { HerdSizeEntry } from '../../../../../interfaces/livestock-summary';

interface SummaryData {
  cows: HerdSizeEntry[];
  cowsThisYear: number | null;
  cowsPrevYear: number | null;
}

export default function HerdSizeSummary({
  summaryData,
  title
}: {
  summaryData: SummaryData;
  title: string;
}) {

  const { t } = useTranslation();
  const reversedCow = [...summaryData.cows].reverse();

  return (
    <div className={css['summary-container']}>
      <div className={css['left-panel']}>
        <div className={css['grid-container']}>
          <SummaryGraph
            title={title}
            height={193}
            xKey="current_date"
            yLeftValue={t('pages.livestock.summary.view.cow')}
            dataObjects={[
              {
                dataKey: "last_control",
                dataTitle: t('pages.livestock.summary.view.cow'),
                strokeColor: "#12589F",
                yAxis: "left"
              },
            ]}
            data={summaryData.cows}
          />
          <p className={css['summary']}>{t('pages.livestock.summary.view.year_average')}</p>
          <hr></hr>

          <table className={css['under-table']}>
            <tbody className={css['strong']}>
              <tr>
                <td>{t('pages.livestock.summary.view.this_year')}</td>
                <td>{summaryData.cowsThisYear}</td>
              </tr>

              <tr>
                <td>{t('pages.livestock.summary.view.prev_year')}</td>
                <td>{summaryData.cowsPrevYear}</td>
              </tr>

              <tr>
                <td>{t('pages.livestock.summary.view.year_difference')}</td>
                <td>{(summaryData.cowsThisYear - summaryData.cowsPrevYear)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className={css['left-panel']}>
        <table className={css['table']} style={{ width: '90%' }}>
          <thead>
            <tr>
              <th>{t('pages.livestock.summary.view.date')}</th>
              <th>{t('pages.livestock.summary.view.cow')}</th>
            </tr>
          </thead>
          <tbody>
            {reversedCow.map((data, index) => (
              <tr key={index}>
                <td>{formatDateValue(data.current_date)}</td>
                <td>{Math.round(data.last_control)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
